import { MeetingAgendaReport } from '../report/MeetingAgendaReport';
import { useAuthContext } from '../../contexts/AuthContext';
import { useParams } from 'react-router-dom';
import { useZoneContext } from '../../contexts/useZoneContext';

function MeetingAgendaReportWrapper() {
    const { guid } = useParams();
    const { user } = useAuthContext();
    const zoneContext = useZoneContext();

    return <MeetingAgendaReport guid={guid || ''} user={user} zoneContext={zoneContext} />;
}

export default MeetingAgendaReportWrapper;
